module.exports = __webpack_public_path__ + "f28eb362fb6afe946d822ee5451c2146.eot";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/OpenSans-Semibold-webfont.eot
// module id = 625
// module chunks = 0